import { useState } from "react";

const REASONS = [
  "Клиент отказался",
  "Не пришёл за заказом",
  "Повреждение на выдаче",
  "Другая причина",
] as const;

interface RefuseModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
  loading?: boolean;
}

export function RefuseModal({ open, onClose, onSubmit, loading = false }: RefuseModalProps) {
  const [reason, setReason] = useState<string>(REASONS[0]);
  const [details, setDetails] = useState("");

  if (!open) return null;

  const fullReason = [reason, details.trim()].filter(Boolean).join(": ");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30" role="presentation">
      <form
        className="w-full max-w-md rounded-lg bg-white p-5 shadow-xl"
        aria-label="Отказ от выдачи"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit(fullReason);
        }}
      >
        <h2 className="text-lg font-semibold text-gray-900">Отказ от выдачи</h2>
        <label className="mt-4 block text-sm font-medium text-gray-700">
          Причина
          <select value={reason} onChange={(event) => setReason(event.target.value)} className="input-admin mt-1 w-full">
            {REASONS.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
        <label className="mt-4 block text-sm font-medium text-gray-700">
          Детали
          <textarea
            value={details}
            onChange={(event) => setDetails(event.target.value)}
            className="input-admin mt-1 min-h-24 w-full"
          />
        </label>
        <div className="mt-5 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="btn-secondary" disabled={loading}>
            Отмена
          </button>
          <button type="submit" className="btn-danger" disabled={loading}>
            Подтвердить отказ
          </button>
        </div>
      </form>
    </div>
  );
}
